import { PayrollVoucherStatusEnum } from "@/enum/payroll-voucher-status";
import { CycleSummary, PayrollVoucher } from "./types";

export const MOCK_VOUCHERS: readonly PayrollVoucher[] = [
  {
    id: 1,
    conciliation_id: 118,
    conciliation_date: "2026-04-19",
    employee_name: "Vanessa Ferreira",
    employee_cpf: "123.877.593-45",
    store_code: "0013",
    amount: 108.73,
    installments_count: 3,
    analyst_justification: "Troco incorreto",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
  {
    id: 2,
    conciliation_id: 119,
    conciliation_date: "2026-04-20",
    employee_name: "Carlos Eduardo Ramos",
    employee_cpf: "981.442.110-07",
    store_code: "0027",
    amount: 62.4,
    installments_count: 1,
    analyst_justification: "Falta de sangria",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
  {
    id: 3,
    conciliation_id: 120,
    conciliation_date: "2026-04-21",
    employee_name: "Patrícia Nunes",
    employee_cpf: "455.208.331-92",
    store_code: "0013",
    amount: 245.9,
    installments_count: 5,
    analyst_justification: "Erro de sistema",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
  {
    id: 4,
    conciliation_id: 121,
    conciliation_date: "2026-04-22",
    employee_name: "Rogério Antunes",
    employee_cpf: "302.775.884-16",
    store_code: "0041",
    amount: 37.15,
    installments_count: 1,
    analyst_justification: "Cancelamento indevido",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
  {
    id: 5,
    conciliation_id: 122,
    conciliation_date: "2026-04-23",
    employee_name: "Luciana Prado",
    employee_cpf: "776.319.002-58",
    store_code: "0027",
    amount: 512,
    installments_count: 10,
    analyst_justification: "Troco incorreto",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
  {
    id: 6,
    conciliation_id: 123,
    conciliation_date: "2026-04-24",
    employee_name: "Marcelo Tavares",
    employee_cpf: "645.100.472-31",
    store_code: "0055",
    amount: 89.99,
    installments_count: 2,
    analyst_justification: "Sem justificativa",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
  {
    id: 7,
    conciliation_id: 124,
    conciliation_date: "2026-04-25",
    employee_name: "Renata Bittencourt",
    employee_cpf: "218.663.905-74",
    store_code: "0041",
    amount: 154.3,
    installments_count: 3,
    analyst_justification: "Falta de sangria",
    status: PayrollVoucherStatusEnum.APPROVED,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 2,
  },
  {
    id: 8,
    conciliation_id: 125,
    conciliation_date: "2026-04-26",
    employee_name: "Thiago Menezes",
    employee_cpf: "534.918.226-60",
    store_code: "0013",
    amount: 73.5,
    installments_count: 4,
    analyst_justification: "Erro de sistema",
    status: PayrollVoucherStatusEnum.REJECTED,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 2,
  },
  {
    id: 9,
    conciliation_id: 127,
    conciliation_date: "2026-04-27",
    employee_name: "Bruno Almeida",
    employee_cpf: "890.234.517-03",
    store_code: "0055",
    amount: 198.2,
    installments_count: 1,
    analyst_justification: "Troco incorreto",
    status: PayrollVoucherStatusEnum.PENDING,
    rejection_reason: null,
    decided_by_email: null,
    conciliation_closed_at: null,
    version: 1,
  },
];

export const MOCK_CYCLE: CycleSummary = {
  cycle: "2026-05",
  interval: "20/04 → 19/05",
  days_to_close: 14,
  vouchers_in_cycle: MOCK_VOUCHERS.length,
  decided_percentage: 78,
  payroll_discount_in_cycle: 102,
  exported_percentage: 93,
};
